// extracted by mini-css-extract-plugin
export default {"referred-record__entity-type":"referred-record__entity-type---gfrLw"};